// @see: https://github.com/streamich/react-use/blob/master/src/useIntersection.ts
import { useEffect, useState } from "react"

export const useIntersection = <T extends HTMLElement>(
  element: T | null,
  options: IntersectionObserverInit,
): IntersectionObserverEntry | null => {
  const [intersectionObserverEntry, setIntersectionObserverEntry] =
    useState<IntersectionObserverEntry | null>(null)

  useEffect(() => {
    if (!element || typeof IntersectionObserver !== "function") {
      return
    }

    const handler = (entries: IntersectionObserverEntry[]) => {
      setIntersectionObserverEntry(entries[0])
    }

    const observer = new IntersectionObserver(handler, options)
    observer.observe(element)

    return () => {
      setIntersectionObserverEntry(null)
      observer.disconnect()
    }
  }, [element, options])

  return intersectionObserverEntry
}
